function arrayFunction<T>(arr: ((param: T) => void)[], param: T): void {
    for (const fn of arr) {
        fn(param);
    }
}

// ----------------------------------------------------------------------------

export default arrayFunction;
